// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"8a22e7bc","36":"2da16ecf","222":"77d63b8f","231":"208fce19","318":"f2e9d936","371":"6464383a","423":"fdc84aad","465":"58ee8581","569":"3b5106c1","638":"2b12c5fe","945":"4a33452c"}[chunkId] + ".chunk.js";
};